module.exports = __webpack_public_path__ + "img/index_map_place04.41a96f28.jpg";